import { render } from "./QuestionSection.vue?vue&type=template&id=f1404baa&ts=true"
import script from "./QuestionSection.vue?vue&type=script&lang=ts"
export * from "./QuestionSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__